import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";
interface EtymologyFormProps {
  term: string;
  isLoading: boolean;
  onTermChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}
const EtymologyForm: React.FC<EtymologyFormProps> = ({
  term,
  isLoading,
  onTermChange,
  onSubmit
}) => {
  return <form onSubmit={onSubmit} className="max-w-2xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="text" placeholder="Ex. Agape, Shalom, Selah, etc..." value={term} onChange={e => onTermChange(e.target.value)} className="flex-1 h-12 px-4 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-heaven-gold/30 focus:border-transparent py-[19px]" />
        <Button type="submit" className="bg-black text-white hover:bg-gray-800 h-12 px-6 rounded-lg w-full sm:w-auto" disabled={isLoading}>
          {isLoading ? <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Analyzing...
            </> : <>
              <Send className="mr-2 h-4 w-4" />
              Send
            </>}
        </Button>
      </div>
    </form>;
};
export default EtymologyForm;